import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, nextTick } from 'vue'
import type { Ref } from 'vue'
import {
  HQ_VPN_LANGUAGE_COOKIE_NAME,
} from '@/const'
import {
  setCookie,
} from '@/utils/cookies'


export default /*#__PURE__*/_defineComponent({
  __name: 'LangSelector',
  props: ['langs-data'],
  setup(__props, { expose }) {
  expose();

const props = __props


const selected = ref({})

async function setLanguage(e) {
  await setCookie(HQ_VPN_LANGUAGE_COOKIE_NAME, (e.id).toLowerCase());
  nextTick(() => {
    window.location.href = selected.value.link
  })
}

onMounted(() => {
  selected.value = props.langsData.find(lang => lang.is_active)
})

const __returned__ = { props, selected, setLanguage, ref, onMounted, nextTick, HQ_VPN_LANGUAGE_COOKIE_NAME, setCookie }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})